/**
 *
 * @module dustEvent
 *
 */

import Check from 'check-types';
import Services from './../../services/entry';

const Dust = Services.Internal.Dust;
const DustPayload = Dust.DustPayload;
const DustClientPayload = Dust.DustClientPayload;
const DustServerPayload = Dust.DustServerPayload;

const InvalidArgumentException = Services.Exception.InvalidArgumentException;

const {
    instanceStrict
} = Check.assert;

/**
 *
 * @class DustEvent
 * @implements {TelemetryEvent}
 *
 */
export default class DustEvent {

    /**
     *
     * @param {SDK.Services.Internal.Dust.DustClientPayload} client
     * @param {SDK.Services.Internal.Dust.DustServerPayload} [server={}]
     *
     */
    constructor(client, server = {}) {

        const errorMessage = {
            ctor: 'DustEvent(client, server)',
            get client() {
                return `${this.ctor} needs SDK.Services.Internal.Dust.DustClientPayload instance`;
            },
            get server() {
                return `${this.ctor} needs SDK.Services.Internal.Dust.DustServerPayload instance`;
            }
        };

        instanceStrict(client, DustClientPayload, errorMessage.client, InvalidArgumentException);

        if (Check.nonEmptyObject(server)) {
            instanceStrict(server, DustServerPayload, errorMessage.server, InvalidArgumentException);
        }

        /**
         *
         * @access public
         * @type {SDK.Services.Internal.Dust.DustClientPayload}
         * @desc Dictionary containing client provided tracking information.
         * @see https://github.bamtech.co/sdk-doc/spec-sdk/blob/master/specs/feature_overviews/dust.md#client-data
         *
         */
        this.client = client;

        /**
         *
         * @access public
         * @type {SDK.Services.Internal.Dust.DustServerPayload|Object}
         * @desc Optional Dictionary containing server provided tracking information.
         * @see https://github.bamtech.co/sdk-doc/spec-sdk/blob/master/specs/feature_overviews/dust.md#server-data
         *
         */
        this.server = server;

    }

    /**
     *
     * @access private
     * @desc assembles a dust payload object
     * @returns {Promise(<SDK.Services.Internal.Dust.DustPayload>} jsonSerializable object
     * @note should take a an empty `Object` for `server` by default
     *
     */
    getPayload() {

        const { client, server } = this;

        return Promise.resolve(new DustPayload(client, server));

    }

}



// WEBPACK FOOTER //
// ./src/internal/dust/dustEvent.js